<template>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title" width="600px" :close-on-click-modal="false"
               :visible.sync="visible" :before-close="handleClose">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 label-width="90px">
            <div class="minTitle">{{ searchForm.messageTitle }}</div>
            <el-form-item label="系统名称：" prop="thematicName">
                <div>{{ $dictUtils.getDictLabel("sys_menu_local_system", searchForm.messageClassification, '') }}</div>
            </el-form-item>
            <el-form-item label="消息分类：" prop="thematicState">
                <div>{{ $dictUtils.getDictLabel("message_type", searchForm.messageType, '') }}</div>
            </el-form-item>
            <el-form-item label="消息时间：" prop="messageData">
                <div>{{ searchForm.messageData }}</div>
            </el-form-item>
            <div class="contetnt">{{ searchForm.messageContent }}
                <el-link @click="knowDetail()" v-if="searchForm.messageType == 4" type="primary">查看详情>></el-link>
            </div>
        </el-form>
        <div slot="footer">
            <el-button size="small" type="primary" @click="switchingData(0)">上一条</el-button>
            <el-button size="small" type="primary" @click="switchingData(1)">下一条</el-button>
            <el-button size="small" @click="handleClose()">关闭</el-button>
        </div>
        <learning-detail ref="learningDetail" @refreshList="visible = false"></learning-detail>
    </el-dialog>
</template>

<script>
import LearningDetail from "@/views/modules/academic/academic/learningDetail.vue";

export default {
    name: "seeMessage",
    components: {LearningDetail},
    data() {
        return {
            title: '消息详情',
            visible: false,
            seleData: {},
            searchForm: {
                messageTitle: '',
                messageClassification: '',
                messageType: '',
                messageData: '',
                messageContent: '',
                businessId: '',
                businessType: '',
            },
            rules: {},
        }
    },

    methods: {
        init(row) {
            this.seleData = row
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            this.getDatail()
        },

        getDatail() {
            this.$axios(this.api.allCommon.commonMessageGetById + this.seleData.id, {}).then(data => {
                if (data && data.status) {
                    this.searchForm = data.data
                    //更新我的未读信息
                    this.$store.commit('user/updateUserMessage')
                }
            })
        },

        knowDetail() {
            this.$axios(this.api.academic.knowledgemodelGetById + this.searchForm.businessId, {}).then(data => {
                if(data.data && data.status){
                    this.$refs.learningDetail.init({
                        id: this.searchForm.businessId,
                        sender: this.searchForm.sender,
                    })
                }else {
                    this.$message.warning('该知识模型已被删除，无法查看详情。')
                }
            })
        },

        // num==0 上一条 1下一条
        switchingData(num) {
            this.$emit('switchData', num)
        },

        handleClose() {
            this.$emit('refresh')
            this.visible = false
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.minTitle {
    font-weight: bold;
    margin-bottom: 10px;
}

.contetnt {
    text-indent: 2em;
}
</style>